import React, { useCallback } from 'react'
import { Grid, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { ResultObjectType } from '@cbgms/api'
import { formatDateTime } from '@cbgms/base/utils/datetime'
import Currency from '@cbgms/components/general/Currency'
import { splitRegistration } from '@cbgms/base/utils/vehicle'
import { ResultTitle } from './Title'
import Build from '@mui/icons-material/Build'
import DriveEta from '@mui/icons-material/DriveEta'
import { StackedIcon } from '@carsys/ui'
import DescriptionIcon from '@mui/icons-material/Description'
import FullName from '@cbgms/components/src/utils/FullName'

const useStyles = makeStyles(() =>
  createStyles({
    pointer: {
      width: '100%',
      cursor: 'pointer'
    }
  })
)

export interface QuotationResultType {
  Type: ResultObjectType
  Quotation: Quotation
  clearQuery: () => void
  primaryAction: () => Promise<void>
  hasGroupHeader: boolean
}

interface Quotation {
  CustomerFirstName: string
  CustomerName: string
  CreatedAt: string
  QuotationNumber: string
  UUID: string
  VehicleManufacturer: string
  VehicleModel: string
  VehicleRegistration: string
  VehicleType: string
  TotalVatIncluded?: number
  WorkorderQuotationUUID?: string
}

export const QuotationResult: React.FC<QuotationResultType> = props => {
  const { Quotation, Type, hasGroupHeader, primaryAction } = props
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )
  const classes = useStyles()
  const Registration = splitRegistration(Quotation.VehicleRegistration)
  return (
    <div className={classes.pointer} onClick={onClick}>
      <Grid container spacing={2}>
        <ResultTitle resultType={Type} isTitleVisible={!hasGroupHeader} />
        <Grid item xs={2}>
          <StackedIcon
            MainIcon={<DescriptionIcon />}
            SecondaryIcon={Type === ResultObjectType.WorkorderQuotation ? <Build /> : <DriveEta />}
          />
        </Grid>
        <Grid item xs={10}>
          <Typography variant='body1' component='h3' style={{ fontWeight: 'bold' }}>
            {Quotation.QuotationNumber} | {formatDateTime(Quotation.CreatedAt)}
            {Type === ResultObjectType.WorkorderQuotation && ' | '}
            {Type === ResultObjectType.WorkorderQuotation && <Currency amount={Quotation.TotalVatIncluded} />}
          </Typography>
          <Typography component='p'>
            {/* eslint-disable-next-line max-len */}
            <FullName firstName={Quotation?.CustomerFirstName || ''} lastName={Quotation?.CustomerName || ''} /> |{' '}
            {Registration.licensePlate} | {Quotation.VehicleManufacturer} {Quotation.VehicleModel} {Quotation.VehicleType}
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}
